import { StrictMode } from 'react'
// The shared Diwata type stack, self-hosted via aether (no CDN — ships offline).
// aether owns the brand faces that the --ae-font-family-* tokens name.
import '@diwata/aether/fonts.css'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import {
  initColorMode,
  initFontPreset,
  initThemePreset,
  initTextScale,
  initAccent,
  initContrast,
  initDensity,
  initMotion,
} from '@diwata/ironvale'
import App from './App'
import { UnauthorizedError } from '@/api/client'
import './components/layout.css'

document.documentElement.setAttribute('data-theme', 'diwa')

// Apply every persisted appearance axis (data-* on <html>) before first paint,
// so the user's saved choices are live on load — no flash of default theme.
initColorMode()
initFontPreset()
initThemePreset()
initTextScale()
initAccent()
initContrast()
initDensity()
initMotion()

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 30_000 } } })

// Global 401 handler — bounce to Diwa's own login (no Gate dependency)
queryClient.getQueryCache().subscribe((event) => {
  if (event.type === 'updated' && event.query.state.error instanceof UnauthorizedError) {
    if (!window.location.pathname.startsWith('/login')) {
      window.location.href = '/login'
    }
  }
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
)

// The PWA shell: offline fallback + push live in the service worker. Prod only —
// a worker in dev would cache-fight HMR.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {})
  })
}
